module.exports = __webpack_public_path__ + "static/media/ongoingPeriod.9783d2ac.svg";